exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".ju52g932uagweyakjdppt1dfntqgsv3g6y5qesasdxd3wpqbcbwaskjfmk5sbpq78gp96m88bmmydf385fsbhdwuszak33vmqny5uq-ActionDrawerWarnings-module-form-group{margin-bottom:12px}", "", {"version":3,"sources":["C:/a/_work/5/s/src/views/ActionDrawer/components/ActionDrawerWarnings/C:/a/_work/5/s/src/views/ActionDrawer/components/ActionDrawerWarnings/ActionDrawerWarnings.module.scss"],"names":[],"mappings":"AAEA,+IACI,kBAAmB,CACtB","file":"ActionDrawerWarnings.module.scss","sourcesContent":["@import '../../../../common-scss/variables.scss';\r\n\r\n.form-group {\r\n    margin-bottom: 12px;\r\n}\r\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"form-group": "ju52g932uagweyakjdppt1dfntqgsv3g6y5qesasdxd3wpqbcbwaskjfmk5sbpq78gp96m88bmmydf385fsbhdwuszak33vmqny5uq-ActionDrawerWarnings-module-form-group"
};